import { Flex, Text } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreBookingPayment } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { useBookingPaymentStatusIcon } from '../../hooks/useBookingPaymentStatusIcon'

export type CellPaymentTypeProps = {
  payment?: CoreBookingPayment
}

export function CellPaymentType({ payment }: CellPaymentTypeProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_payments' })

  const data = useBookingPaymentStatusIcon({ payment })

  return (
    <Flex align='center' gap='sm'>
      <Icon
        color={data.color}
        icon={data.icon}
        size='sm'
        withCircleBackground
        style={{ flexShrink: 0 }}
      />
      <Text>{t(data.label)}</Text>
    </Flex>
  )
}
